export enum TSMessageEvent {
    ERROR_UPDATE = <any> 'ERROR_UPDATE',
    INFO_UPDATE= <any> 'INFO_UPDATE',
    CLEAR = <any> 'CLEAR',
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSErrorEvent.ts